import { render, staticRenderFns } from "./SaveEvaluationForm.vue?vue&type=template&id=65115247&"
import script from "./SaveEvaluationForm.vue?vue&type=script&lang=js&"
export * from "./SaveEvaluationForm.vue?vue&type=script&lang=js&"
import style0 from "./SaveEvaluationForm.vue?vue&type=style&index=0&id=65115247&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports